module.exports = __webpack_public_path__ + "img/sm_yt.049290d9.png";